import type { IconSvgObject } from './types';

const DiggIcon: IconSvgObject = [
  ["path", { d: "M9 5V6.01551M9 9.06204V16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5.99971 9H1.99994V16H5.99971V9ZM5.99971 9V5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M15.5038 16H11.5001V9H15.5001L15.5038 16ZM15.5038 16L15.504 19H11.4999", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M21.9998 16H18.0002V9H21.9998V16ZM21.9998 16L22.0003 19H17.9999", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default DiggIcon;
